import { render } from "./Stalls.vue?vue&type=template&id=2412846c"
import script from "./Stalls.vue?vue&type=script&lang=js"
export * from "./Stalls.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__